<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>
            <v-col cols="12" lg="3">
                <v-card class="mx-auto" light>
                    <v-card-title>Tutorial Sections</v-card-title>
                    <v-divider light />
                    <v-list light>
                        <v-list-item-group v-model="selectedTutorial">
                            <v-list-item v-for="(item, i) in tutorialsManifest" :key="i">
                                <v-list-item-icon>
                                    <v-icon v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-col>


            <v-col cols="12" lg="9">

                <info-section v-for="(item, i) in tutorialsManifest" :key="i" :section="item" v-if="selectedTutorial == i" />

            </v-col>

        </v-row>
        
    </v-container>
</template>

<script>
import InfoSection from "@/components/Tutorials/InfoSection";
export default {
    name: 'Tutorials',
    props: [''],
    components: {
        InfoSection
    },
    data: () => ({
        selectedTutorial: 0,
        tutorialsManifest: [],

        //show: false
    }),

    computed: {
        accessKey() {
            return this.$store.state.tutorialsAccessKey;
        }
    },

    methods: {
        getTutorialsManifest: function() {
            let route = `https://tutorials.telsasoft.com?access=${this.accessKey}`;
            return this.$http.get(route).then(response => {
                let result = response.bodyText;
                this.tutorialsManifest = JSON.parse(result);
                // for(let section of this.tutorialsManifest) {
                //     if(section.documentationLink) {
                //         let docRoute = `${section.documentationLink}?access=${this.accessKey}`;
                //         this.$http.get(docRoute).then(response => {
                //             console.log(response);
                //             section.documentationHtml = response.bodyText;
                //         });
                //     }
                //     else {
                //         section.documentationHtml = null;
                //     }
                // }
                if(this.$store.state.tutorialsShortcut) {
                    this.selectedTutorial = this.tutorialsManifest.findIndex(m => m.text == this.$store.state.tutorialsShortcut);
                    this.$store.commit('setTutorialsShortcut', null);
                }
            });
        },

        getTutorialDocumentation: function() {

        }
    },

    mounted() {
        this.getTutorialsManifest();
    }

  
};
</script>

<style scoped>


</style>
